import { Component, OnInit } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../core/config/Constants';
import { UtilityService } from '../../core/services/utility.service';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { SponsorsService } from '../../core/services/sponsors.service';
import { Sponsors } from '../../core/models/sponsors';
import { Category } from '../../core/models/category';
import { MultiUtilityService } from '../../core/services/multi-utility.service';
import { Listing } from '../../core/models/listing';
import { HideImage } from '../../core/models/hideImage';

@Component({
	selector: 'app-sponsors-form',
	templateUrl: './sponsors-form.component.html',
	styleUrls: ['./sponsors-form.component.css'],
	providers: [ExtraService, UtilityService, SponsorsService]
})
export class SponsorsFormComponent implements OnInit {

	eventID: string;
	message: string;

	categoryItemNewText: string = null;
	categoryList: Array<Category> = new Array();
	categoryDeletedIdList: Array<string> = new Array();

	sponsorId: string;
	sponsorsList: Array<Sponsors> = [];

	checkData: boolean = false;

	hasListOrderChanged: boolean = false;
	hasCategoryOrderChanged: boolean = false;

	listing = new Listing();
	hideImage = new HideImage();


	constructor(private extraService: ExtraService, private route: ActivatedRoute,
		private confirmationService: ConfirmationService, private multiUtilityService: MultiUtilityService,
		private sponsorService: SponsorsService) {
		// super();
	}

	ngOnInit() {
		this.extraService.changeStateofSideBarButton(true);
		this.extraService.changeSideBar(true);
		this.route.params.subscribe(params => {
			console.log(params);
			if (params['eventId']) {
				this.eventID = params['eventId'];
				this.extraService.setCurrentEventId(params['eventId']);
				this.checkData = true;
				this.initCategoryList(params['eventId']);
				this.getSponsorsList(params['eventId']);

				this.multiUtilityService.getPrefListing(params['eventId'], Constants.LIST_CATEGORY_SPONSOR).subscribe(pref => {
					this.listing.has_category_sponsor = pref;
				});

				this.multiUtilityService.getPrefHiding(params['eventId'], Constants.HIDE_IMAGE_SPONSOR).subscribe(pref => {
					this.hideImage.hideImageSponsor = pref;
				});
			}
		});
	}

	getSponsorsList(eventId: string) {
		let x = this.sponsorService.getSponsorsList(eventId);
		x.snapshotChanges().subscribe(list => {
			if (this.checkData) {
				this.sponsorsList = [];
				list.forEach(element => {
					let y = element.payload.toJSON() as Sponsors;
					y['$key'] = element.key;
					this.sponsorsList[y.position] = (y as Sponsors);
				});
				console.log(this.sponsorsList);
				this.checkData = false;
			}
		});
	}
	
	/*	CATEGORY RELATED FUNCTIONS	*/
	initCategoryList(eventId) {
		this.multiUtilityService.getCategoryList(eventId, Constants.CATEGORY_SPONSORS).subscribe(event => {
			if (event) {
				this.categoryList = new Array();
				for (let key in event) {
					let categoryItem = new Category();
					categoryItem.$key = key;
					categoryItem.position = event[key].position;
					categoryItem.text = event[key].text;
					this.categoryList[event[key].position] = categoryItem;
				}
				console.log('initCategoryList	:	' + this.categoryList.length);
			}
		});
	}

	onCategoryTextChange() {
		// console.log('onCategoryTextChange');
		this.hasCategoryOrderChanged = true;
	}

	addCategoryItem() {
		if (this.categoryItemNewText != null && this.categoryItemNewText.trim().length > 0) {
			this.hasCategoryOrderChanged = true;

			let categoryItem = new Category();
			categoryItem.$key = null;
			categoryItem.position = this.categoryList.length;
			categoryItem.text = this.categoryItemNewText;
			this.categoryList.push(categoryItem);

			// Commented by Pranav
			for (var i = 0; i < this.categoryList.length; i++) {
				this.categoryList[i].position = i;
			}

			let key = this.multiUtilityService.addCategoryItem(this.eventID, this.categoryList, Constants.CATEGORY_SPONSORS);
			if (key) {
				this.message = 'Type Added Successfully';
				this.categoryItemNewText = null;
				setTimeout(() => {
					this.message = null;
					this.checkData = true;
				}, 1000);
			}
		}
	}

	upCategoryItem(index) {
		if (index != 0) {
			this.swapCategoryItem(index, index - 1);
		}
	}

	downCategoryItem(index) {
		if (index != this.categoryList.length - 1) {
			this.swapCategoryItem(index, index + 1);
		}
	}

	swapCategoryItem(index1, index2) {
		this.hasCategoryOrderChanged = true;

		let data = this.categoryList[index1];
		this.categoryList[index1] = this.categoryList[index2];
		this.categoryList[index2] = data;
	}

	confirmDeleteCategoryItem(item) {
		this.confirmationService.confirm({
			message: Constants.DELETE_MSG_SPONSOR + ' ' + item.text,
			accept: () => {
				this.deleteCategoryItem(item);
			}
		});
	}

	deleteCategoryItem(item) {
		this.hasCategoryOrderChanged = true;

		this.categoryDeletedIdList.push(item.$key);
		let index: number = this.categoryList.indexOf(item);
		if (index !== -1) {
			/* Remove category from List */
			this.categoryList.splice(index, 1);

			/* Reset position in categoryList */
			for (var i = 0; i < this.categoryList.length; i++) {
				this.categoryList[i].position = i;
			}
		}
	}

	/*	CATEGORY RELATED FUNCTIONS - END	*/

	/* <T> object related functions */
	upListItem(index) {
		console.log('testtt');
		if (index != 0) {
			this.swapListItem(index, index - 1);
		}
	}

	downListItem(index) {
		if (index != this.sponsorsList.length - 1) {
			this.swapListItem(index, index + 1);
		}
	}

	swapListItem(index1, index2) {
		this.hasListOrderChanged = true;

		let data = this.sponsorsList[index1];
		this.sponsorsList[index1] = this.sponsorsList[index2];
		this.sponsorsList[index2] = data;
	}



	confirmDeleteListItem(event: Sponsors, value: string) {
		this.confirmationService.confirm({
			message: Constants.DELETE_MSG_EXH,
			accept: () => {
				this.deleteListItem(event);
			}
		});
	}

	deleteListItem(event: Sponsors) {
		this.hasListOrderChanged = true;

		let index: number = this.sponsorsList.indexOf(event);
		if (index !== -1) {
			this.sponsorsList.splice(index, 1);
			for (var i = 0; i < this.sponsorsList.length; i++) {
				this.sponsorsList[i].position = i;
			}
		}

		this.sponsorService.deletegetSponsor(event, this.eventID, this.sponsorsList).then(res => {
			this.message = 'Sponsors deleted Successfully';
			setTimeout(() => {
				this.message = null;
				this.checkData = true;
				this.getSponsorsList(this.eventID);
			}, 1000);
		}).catch(error => {
			console.log(error.message);
		});
	}
	/* <T> object related functions */

	submit() {
		console.log('		hasCategoryOrderChanged		' + this.hasCategoryOrderChanged + 'hasListOrderChanged	' + this.hasListOrderChanged);
		if (this.hasListOrderChanged) {
			/* Reset position of List from 0 */
			for (var i = 0; i < this.sponsorsList.length; i++) {
				this.sponsorsList[i].position = i;
			}

			// TODO: Use a callback
			this.sponsorService.updateSponsorPosition(this.eventID, this.sponsorsList);
			this.message = 'Sponsors Updated';

			setTimeout(() => {
				this.message = null;
				this.checkData = true;
			}, 2000);
		}

		if (this.hasCategoryOrderChanged) {
			for (let i = 0; i < this.categoryList.length; i++) {
				this.categoryList[i].position = i;
			}
			let key = this.multiUtilityService.addCategoryItem(this.eventID, this.categoryList, Constants.CATEGORY_SPONSORS);
			if (this.categoryDeletedIdList.length > 0) {
				for (let item of this.categoryDeletedIdList) {
					this.multiUtilityService.deleteCategoryItem(this.eventID, item, Constants.CATEGORY_SPONSORS).then(res => {
						this.message = 'Type deleted Successfully';
						if (this.categoryDeletedIdList.indexOf(item) == this.categoryDeletedIdList.length) {
							this.initCategoryList(this.eventID);
						}
					});
				}
			} else {
				this.message = 'Type ordered Successfully';
			}
			setTimeout(() => {
				this.message = null;
				this.checkData = true;
			}, 2000);
		}
		// this.sponsorService.updateSponsorsListingPref(this.eventID, this.listing.has_category_sponsor);
		this.multiUtilityService.updatePrefListing(this.eventID, Constants.LIST_CATEGORY_SPONSOR, this.listing.has_category_sponsor);
		this.multiUtilityService.updatePrefHiding(this.eventID, Constants.HIDE_IMAGE_SPONSOR, this.hideImage.hideImageSponsor);
	}


}



// WEBPACK FOOTER //
// /app/src/app/event/sponsors-form/sponsors-form.component.ts